<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
    <FloatingCartButton />
  </div>
</template>

<script>
import FloatingCartButton from "@/components/FloatingCartButton.vue";
export default {
  components: { FloatingCartButton }
};
</script>
